import { optionSchema } from '@/common/schemas/option.schema'
import { z } from 'zod'

export const updateUserAccessSchema = z.object({
  company: z.object({
    allowed_driver_equipment_branch_hierarchy_for_consumption: optionSchema,
    branch_hierarchy_for_user_access: optionSchema,
    driver_license_requirements_for_consumptions: optionSchema,
  }),
})

export type UpdateUserAccessSchema = z.infer<typeof updateUserAccessSchema>
